import React from "react";
import logo from "../assets/Group 116.png";
import facebookIcon from "../assets/Facebook Icon.svg";
import youtubeIcon from "../assets/mdi_youtube.svg";
import linkedinIcon from "../assets/Group 1618873847.png";
import playIcon from "../assets/instagram 1.svg";
import razorpayLogo from "../assets/Group (1).png";

const countries = [
  "USA", "Canada", "UK", "Australia", "Germany","France", "India", "Japan", "China", "Brazil","South Africa", "Italy", "Spain", "Netherlands", "Singapore",
];

const Footer = () => {
  // Calculate number of columns and rows per column

  return (
    <div>

    
    <footer className="footer" style={{ padding: "0 9%",paddingBottom: '10px',   
      background: "linear-gradient(to top left, #d3b7ff 0%, #ffffff 50%)",    }}>
       <div
        className="footer-container"
        style={{
          maxWidth: "100%",
        }}
      >
        
            <div style={{ display:"flex",flexWrap:'wrap',paddingLeft: 0, fontSize: "12px",color: '#5E6282',gap: "10px", marginBottom: "20px" }}>
              {countries.map((country, idx) => (
                <span style={{whiteSpace:'nowrap'}} key={idx}>{country} Tour Packages</span>
              ))}
            </div>
      </div> 

      <hr style={{ width: "100%", border: "1px solid #777777", marginBottom: "20px" }} />

      {/* Second Section - Main Footer Links */}
      <div className="footer-container" style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "30px",
      }}>
        {[
          { title: "Our Offerings", items: ["Holidays", "Visa", "Forex", "Hotels", "Flights"] },
          { title: "Popular Destinations", items: ["Airline Fees", "Airline", "Low Fare Tips"] },
          { title: "Vigovia Specials", items: ["Featured Experience", "Group Tour", "Low Fare Tips","Offline events"] },
          { title: "Company", items: ["About Us", "Careers", "Vigovia Blog", "Partners", "Accreditations"] },
          { title: "Offers", items: ["Airline Fees", "Airline", "Low Fare Tips"] }
        ].map((section, index) => (
          <div key={index} className="footer-column" style={{ flex: "1", minWidth: "150px",color: '#5E6282'}}>
            <h2 style={{ textAlign: "left", fontSize: "14px",fontWeight:'600',color: '#5E6282' }}>{section.title}</h2>
            <div style={{ paddingLeft: 0, fontSize: "12px", color: '#5E6282', listStyle: "none", textAlign: "left",height: '100%' ,justifyContent: 'space-between',display:'flex',flexDirection:'column'}}>
              {section.items.map((item, idx) => (
                <div style={{marginTop:'10px'}} key={idx}>{item}</div>
              ))}
            </div>
            
          </div>
          
        ))}

        <div style={{ textAlign:"right",display:'flex',flexDirection:'column',gap:'10px',fontSize:'0.8rem',alignItems:'flex-end' }}>
          <div style={{backgroundColor:'#321e5d',padding:'5px',color:'#ffffff',borderRadius:'30px',width:'140px',fontWeight:'600'}}>Need help? Call us</div>
          <div style={{color: '#321E5D',fontWeight:'600'}}>+91-98xxx64641</div>
          <div>
            <div style={{color: '#321E5D',fontWeight:'600'}}>E-mail</div>
            <div style={{color: '#321E5D'}}>contact@vigovia.com</div>
          </div>
          <div>
            <div style={{color: '#321E5D',fontWeight:'600'}}>Address</div>
            <div style={{color: '#321E5D'}}>HD-109 Cinnabar Hills,Links Business</div>
            <div style={{color: '#321E5D'}}>Park, Bangalore</div>
            <div style={{color: '#321E5D'}}>North,Bangalore,Karnataka,India-560071</div>
          </div>
        </div>
      </div>


      
      <hr style={{ width: "100%", border: "1px solid #777777", marginTop: "20px", marginBottom: "20px" }} />

      {/* New Section - Logo, Payment, Contact */}
      <div className="footer-bottom-container" style={{
        display: "flex", alignItems: "center", flexWrap: "wrap"
      }}>
        {/* Left Edge - Logo */}
        <div style={{ flex: "1", textAlign: "left" }}>
          <img src={logo} alt="Company Logo" style={{ height: "40px" }} />
        </div>

        {/* Middle - Payment Section */}
        <div style={{display:'flex',flexDirection:'column', flex: "1"}}>
          <h3 style={{ fontSize: "14px", color: "grey", marginBottom: "10px",color: '#5E6282',fontWeight: '700'
 }}>Payments</h3>
          <div style={{ display: "flex",backgroundColor:'#ffffff',width:'max-content',padding:'8px',borderRadius:'10px',}}>
            <img src={razorpayLogo} alt="Razorpay" style={{ width : "50px",height:'auto'}} />
          </div>
        </div>
      </div>

      
      

    </footer>
    {/* Bottom Section - Copyright & Policies */}
      <div class="d-flex flex-column flex-lg-row align-items-center align-items-lg-start" style={{
        height:'100%',background: 'linear-gradient(to right, #321E5D 50%, #936FE0)',color:'white',justifyContent: "space-between", alignItems: "center", fontSize: "14px", fontWeight: "700",paddingBottom:'30px',paddingTop:'10px',paddingLeft:'9%',paddingRight:'9%'}}>
        {/* Left - Copyright */}
        <p style={{ textAlign: "left",  }}>
          &copy; 2025 Vigovia Travel Technologies (P) Ltd. All rights reserved.
        </p>

        {/* Social Icons */}
        <div className="footer-column" style={{ minWidth: "200px", display: "flex", flexDirection: "column" }}>
          <div className="social-icons" style={{
            display: "flex", gap: "15px", justifyContent: "flex-start", alignItems: "center"
          }}>
            {[youtubeIcon,linkedinIcon,facebookIcon,playIcon].map((icon, index) => (
              <div key={index} style={{
                width: "35px", height: "35px", borderRadius: "50%", backgroundColor: "white",
                display: "flex", justifyContent: "center", alignItems: "center", boxShadow: "0px 2px 5px rgba(0,0,0,0.2)"
              }}>
                <img src={icon}></img>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Policies */}
        <p style={{ textAlign: "right",display: "flex", flexDirection: "row" }}>
          <span style={{ marginRight: "15px",fontWeight: '400' }}>Privacy Policy</span>
          <span style={{ marginRight: "15px",fontWeight: '400'}}>Legal Notice</span>
          <span style={{fontWeight: '400'}}>Accessibility</span>
        </p>
      </div>
    </div>
  );
};

export default Footer;
